import { AfterViewChecked, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Invoice } from '@modules/invoice/entities';
import { ZoomComponent } from '@shared/zoom/zoom.component';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-invoice-viewer-component',
  templateUrl: './invoice-viewer-component.component.html',
  styleUrls: ['./invoice-viewer-component.component.scss']
})
export class InvoiceViewerComponentComponent implements OnInit, AfterViewChecked {
  @Input() invoice!: Invoice;
  @Input() page!: number;
  @Input() isFullScreen!: boolean;
  @Input() dropdownCurrentPage!: number;
  @Input() pageLegnthDropdown!: any[];
  @Input() carouselOptions!: OwlOptions;

  @Input() buttonColor: string = '';

  @Output() pageChanged = new EventEmitter<{ page: number, isPrevious?: boolean }>();
  @Output() fullScreenToggle = new EventEmitter<any>();

  @ViewChild('owlCar', { static: false }) owlCar: any;
  @ViewChild(ZoomComponent) zoomComponent!: ZoomComponent;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewChecked(): void {
    if (this.owlCar && this.invoice) {
      this.owlCar.to(this.invoice.id);
    }
  }

  endDrag() {
    this.zoomComponent?.endDrag();
  }

  onChangePage(newPage: number, isPrevious = false) {
    this.pageChanged.emit({ page: newPage, isPrevious });
  }

  onFullScreenToggle(event: any) {
    this.fullScreenToggle.emit(event);
  }


}
